import * as constants from './ai.constants';

export const getPrompts = (state) => state.getIn([constants.AI, constants.PROMPTS]);

export const getIsLoading = (state) => state.getIn([constants.AI, constants.IS_LOADING]);
